import React, { useEffect } from "react"
import { useSelector, useDispatch } from "react-redux"

import { VIEW, EDIT, YES, ACTIVE } from "const"
import {
    StoreType,
    moduleIds,
    setSilSafetyFunctionBaseRoute,
} from "client/store"
import {
    projectsRoute,
    projectBaseRoute,
    silSafetyFunctionsRoute,
} from "client/parts/routes"
import { Switch, Route } from "client/components"

import AccessDenied from "client/parts/accessDenied"

import List from "./list"
import View from "./view"
import Edit from "./edit"

const SilSafetyFunction = () => {
    const project = useSelector((state: StoreType) => state.project.projectView)
    const packageSettings = useSelector((state: StoreType) => state.system.packageSettings)
    const moduleList = useSelector((state: StoreType) => state.module.moduleList)
    const dispatch = useDispatch()

    // available only on project level
    const { silModuleAccess } = packageSettings
    const moduleAccess = silModuleAccess === YES && moduleList[moduleIds.sil].status === ACTIVE

    const baseRouteMask = `${projectBaseRoute}${silSafetyFunctionsRoute}`
    const baseRoute = `${projectsRoute}/${VIEW}/${project.id}${silSafetyFunctionsRoute}`

    useEffect(() => {
        dispatch(setSilSafetyFunctionBaseRoute(baseRoute))
    }, [])

    if (!moduleAccess) return <AccessDenied />
    return (
        <Switch>
            <Route
                path={`${baseRouteMask}/${VIEW}/:safetyFunctionId`}
                component={View}
            />
            <Route
                path={`${baseRouteMask}/${EDIT}/:safetyFunctionId`}
                component={Edit}
            />
            <Route
                path={baseRouteMask}
                component={List}
            />
        </Switch>
    )
}
export default SilSafetyFunction
